import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import {BrowserRouter} from 'react-router-dom'
import App from './App'
import createStore from './store';
import {Provider} from 'react-redux'


if (process.env.REACT_APP_H3_ENV === 'prod') {
    const noop = () => {}

    console.log = noop
    console.info = noop
    console.warn = noop
    console.error = noop
    console.debug = noop
}

const store = createStore();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
    <BrowserRouter>
        <Provider store={store}>
            <App />
        </Provider>
    </BrowserRouter>
)
